import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

import { IApiResponse, IBillingCycle } from "../patients/index.type";

const useGetDates = ({ patientId }: { patientId?: string }) => {
  const [datesData, setDatesData] = React.useState<IBillingCycle[]>();

  const { loading: datesLoading, makeApiCall } = useApi({
    url: `/rtm/billing-cycle/dates/${patientId}`,
    method: "GET",
  });

  const getDates = async () => {
    const { response, error } = await makeApiCall<undefined, IApiResponse>();

    if (response?.status === "success") {
      setDatesData(response.data);
    }

    if (response?.status === "fail") {
      toast.error(response.message);
      setDatesData(undefined);
    }

    if (error) toast.error((error.message as string) || error.msg);
  };

  return { datesData, getDates, datesLoading };
};

export default useGetDates;
